import { defineMessages } from "react-intl";

export const transactionRefundReasonMessages = defineMessages({
  reasonForRefund: {
    defaultMessage: "Reason notes",
    id: "s3jmO9",
    description: "input label",
  },
  optionalPlaceholder: {
    defaultMessage: "Optional",
    id: "F8pCg4",
    description: "input placeholder",
  },
});
